import type { InjectionKey } from "vue";

export type TicketPreviewNavigation = (_ticketUuid: string) => Promise<void>;

export const ticketPreviewNavigationKey: InjectionKey<TicketPreviewNavigation> =
  Symbol("ticketPreviewNavigation");
